export const MAIN_SEARCH_CAR_TEST_IDS = {
  // ─── Car Search Form ───
  formContainer: 'main-search-car-form-container',
  title: 'main-search-car-title',

  // ─── Form Fields ───
  pickUpLocationSelect: 'main-search-car-pickup-location-select',
  dropOffLocationSelect: 'main-search-car-dropoff-location-select',
  ageRangeCheckbox: 'main-search-car-age-range-checkbox',
  pickUpDate: 'main-search-car-pickup-date',
  dropOffDate: 'main-search-car-dropoff-date',
  pickUpTime: 'main-search-car-pickup-time',
  dropOffTime: 'main-search-car-dropoff-time',

  // ─── Actions ───
  searchButton: 'main-search-car-search-btn',
} as const;
